module.exports = __webpack_public_path__ + "static/1-37992c1d77d3abca03584e9297652d00.jpg";